import { render, staticRenderFns } from "./PopupInputSupportMc.vue?vue&type=template&id=10d5e968&scoped=true"
import script from "./PopupInputSupportMc.vue?vue&type=script&lang=js"
export * from "./PopupInputSupportMc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d5e968",
  null
  
)

export default component.exports